import React, { useEffect, useState } from "react";
import { Panel, Group as PanelGroup, Separator as PanelResizeHandle } from "react-resizable-panels";
import { X } from "lucide-react";
import PreviewStage from "./omnicraft/PreviewStage";
import CodeDrawer from "./omnicraft/CodeDrawer";
import ChatPane from "./omnicraft/ChatPane";
import TerminalDrawer from "./omnicraft/TerminalDrawer";

export default function OmniCraft({ token }) {
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    // Global bridge for CodeDrawer "Gemini Assist" quick actions.
    function handler(e) {
      const input = document.querySelector('[data-testid="omnicraft-prompt"]');
      if (!input) return;
      input.focus();
      const setter = Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, "value").set;
      setter.call(input, e.detail.prompt);
      input.dispatchEvent(new Event("input", { bubbles: true }));
    }
    window.addEventListener("omnicraft:assist", handler);
    return () => window.removeEventListener("omnicraft:assist", handler);
  }, []);

  return (
    <div
      className="relative rounded-2xl overflow-hidden shadow-2xl bg-[#0B0D12] h-[820px] flex flex-col text-white"
      data-testid="admin-omnicraft"
    >
      <div className="flex-1 min-h-0">
        <PanelGroup direction="horizontal">
          <Panel defaultSize={52} minSize={30}>
            <PanelGroup direction="vertical">
              <Panel defaultSize={62} minSize={30}>
                <PreviewStage token={token} />
              </Panel>
              <PanelResizeHandle className="h-1 bg-white/5 hover:bg-emerald-500/40 transition-colors" />
              <Panel defaultSize={38} minSize={15}>
                <CodeDrawer expanded={false} onToggleExpand={() => setExpanded(true)} />
              </Panel>
            </PanelGroup>
          </Panel>
          <PanelResizeHandle className="w-1 bg-white/5 hover:bg-emerald-500/40 transition-colors" />
          <Panel defaultSize={48} minSize={28}>
            <ChatPane token={token} />
          </Panel>
        </PanelGroup>
      </div>
      <TerminalDrawer />

      {expanded && (
        <div
          className="absolute inset-0 z-40 bg-[#0B0D12]/95 backdrop-blur-md p-4 flex flex-col"
          data-testid="omnicraft-code-modal"
        >
          <div className="flex items-center justify-between mb-3">
            <div className="text-xs uppercase text-emerald-300 tracking-wider">
              OmniCraft · Code Workspace
            </div>
            <button
              onClick={() => setExpanded(false)}
              className="p-1.5 rounded hover:bg-white/10 text-white/60"
              data-testid="omnicraft-close-modal"
            >
              <X size={14} />
            </button>
          </div>
          <div className="flex-1 min-h-0 border border-white/10 rounded-lg overflow-hidden">
            <CodeDrawer expanded={true} onToggleExpand={() => setExpanded(false)} />
          </div>
        </div>
      )}
    </div>
  );
}
